import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import Modal from "../../components/Modal";
import { Icon } from "@iconify/react";
import { TestLabels, Employees } from "../../utils/DropDown";
import Badge from "../../components/Badge/Badge";
import ButtonCount from "../../components/ButtonCount/ButtonCount";
import useStyles from "./styles";

// --| Dummy data
import resourcesData from "../../dummy_data/resources.json";
import { Link } from "react-router-dom";
import InputGroup from "../../components/FormComponent/InputGroup";
import SelectGroup from "../../components/FormComponent/SelectGroup";

const Resources = () => {
  const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  // const [createLabelModal, setCreateLabel] = useState(false);
  const [addInfoModal, setAddInfoModal] = useState(false);
  const [editInfoModal, setEditInfoModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleEditInfoModal = (row) => {
    setEditInfoModal(!editInfoModal);
    setCurrentRow(row);
  };

  const handleCloseEditInfo = () => {
    setEditInfoModal(false);
  };

  const handleAddInfoModal = () => {
    setAddInfoModal(!addInfoModal);
  };

  const handleCloseAddInfoModal = () => {
    setAddInfoModal(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    // The data will be from the knowledgebase get api endpint
    setSearchResult(resourcesData);
  }, []);
  const columns = [
    {
      name: "Title",
      selector: row => row?.title
    },
    {
      name: "Label",
      selector: row => row?.label
    },
    {
      name: "Type",
      selector: row => row?.type
    },
    {
      name: "Expiry date",
      selector: row => row?.expiry?.substring(0, 10)
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/resources/${row?.id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link>
          <button className="table-action-icon" onClick={() => {
            handleEditInfoModal(row);
          }}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = resourcesData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.title
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.label
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.type
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Resources"
            subtitle="See a list of all the resources that has been shared throughout the organisation."
            button={
              <div className="flex gap-10">
                <Button
                  variant="primaryoutline"
                  buttonSize="medium"
                  color="btnfontprimary"
                  buttonName="Create new label"
                />
                <Button
                  variant="primary"
                  buttonSize="medium"
                  color="btndefault"
                  buttonName="Add new info"
                  onClick={handleAddInfoModal}
                />
              </div>
            }
          />
          <div className={classes.buttoncountcontainer}>
            <ButtonCount title="Material Category Count" count={0} />
          </div>
          <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchTeacher} />
          }
          />
          <Modal
            title="Delete Resource"
            subtitle={
              <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.title}</span>. If resource is deleted, employee will no longer have access to this resource.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <Button variant="danger" buttonName="Delete Resource" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />

          <Modal
            title="Add a New Resource"
            subtitle={
              <div>Add a document to your knowledge base for your employees to have access to.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="Add Title of Document"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Labels" children={
                      <select>
                        <option value="">---Select Labels ---</option>
                        {TestLabels?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Who can access" children={
                      <select>
                        <option value="">---Select who can access ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Due Date"
                      margin="normal"
                      inputType="date"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.pickercontainer}>
                      <input type="file" className={classes.picker} />

                      <div className={classes.uploadflex}>
                        <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                        <div>
                          <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                          <h6 className={classes.uploadsubtitle}>SVG,PNG,JPG,GIF| 10MB max.</h6>
                        </div>
                      </div>
                      <div className={classes.rightpicker}>
                        <div className={classes.uploadbutton}>Upload</div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Add Document" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={addInfoModal}
            closeModal={handleCloseAddInfoModal}
          />

          {/* Edit a Modal */}

          <Modal
            title={`Edit Resource for ${currentRow?.title}`}
            subtitle={
              <div>Edit the knowledge base info for {currentRow?.title}
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Title"
                      margin="normal"
                      placeHolder="Add Title of Document"
                      inputType="text"
                      defaultValue={currentRow?.title}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Labels" children={
                      <select defaultValue={currentRow?.label}>
                        <option value="">---Select Labels ---</option>
                        {TestLabels?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Who can access" children={
                      <select defaultValue={currentRow?.access}>
                        <option value="">---Select who can access ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Due Date"
                      margin="normal"
                      inputType="date"
                      defaultValue={currentRow?.expiry}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.pickercontainer}>
                      <input type="file" className={classes.picker} />

                      <div className={classes.uploadflex}>
                        <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                        <div>
                          <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                          <h6 className={classes.uploadsubtitle}>SVG,PNG,JPG,GIF| 10MB max.</h6>
                        </div>
                      </div>
                      <div className={classes.rightpicker}>
                        <div className={classes.uploadbutton}>Upload</div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Edit Document" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={editInfoModal}
            closeModal={handleCloseEditInfo}
          />
        </>
      }
    />
  );
};

export default Resources;
